import type {
  CareplanProductDataModel,
  PreviousCareplanProductDataModel,
  PreviousCareplanProductResponse,
} from "@/domains/careplan/models/types";
import { formatAmountAsString } from "@/utils/money";

export const createCareplanPreviousProductDataModel = (
  product: PreviousCareplanProductResponse,
) => {
  return {
    ...product,
    images: [product.image],
    priceAsString: formatAmountAsString(`${product.price / 100}`),
    whyRecommended: {
      title: product.whyRecommended,
    },
    isPrevious: true,
  };
};

export const isPreviousProduct = (
  product: CareplanProductDataModel | PreviousCareplanProductDataModel,
) => {
  return product.isPrevious && (product as PreviousCareplanProductDataModel);
};
